import {
    Box,
    Button,
    CircularProgress,
    IconButton,
    Stack,
} from "@mui/material";
import { useEffect, useState } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import ListView from "../components/ListView/ListView";
import RoleForm from "../components/Roles/RoleForm";
import RoleInfo from "../components/Roles/RoleInfo";
import { userColumns } from "../constants/dataGridColumns";
import Window from "../components/Window/Window";
import useApiRequest from "../hooks/useApiRequest";

const RoleDetail = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const id = state?.id;

    const isNewRole = !id;

    const { data, loading, read, remove } = useApiRequest(`/roles`, !isNewRole);

    const {
        data: users,
        loading: loadingUsers,
        list,
    } = useApiRequest(`/roles/${id}/users`, !isNewRole);

    useEffect(() => {
        if (!isNewRole) {
            read(id);
            list();
        }
        // eslint-disable-next-line
    }, [id]);

    const [isEditing, setIsEditing] = useState(isNewRole);

    const handleEditToggle = () => {
        setIsEditing(!isEditing);
    };

    const handleDelete = async () => {
        const confirmDelete = window.confirm(
            "¿Estás seguro de que deseas eliminar este rol?"
        );
        if (confirmDelete) {
            try {
                await remove(id);
                navigate("/roles");
            } catch (error) {
                console.error("Error al eliminar el rol:", error);
            }
        }
    };

    return (
        <Window title={isNewRole ? "Nuevo Rol" : "Detalles del Rol"}>
            {loading && !isNewRole ? (
                <CircularProgress />
            ) : (
                <>
                    <Stack
                        direction="row"
                        spacing={2}
                        justifyContent={"space-between"}
                    >
                        {isEditing ? (
                            <RoleForm
                                isNew={isNewRole}
                                refreshData={() => read(id)}
                                setIsEditing={setIsEditing}
                                initialRoleData={data}
                            />
                        ) : (
                            <RoleInfo role={data} />
                        )}
                        <Box>
                            {!isNewRole &&
                                (isEditing ? (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleEditToggle}
                                    >
                                        Cancelar
                                    </Button>
                                ) : (
                                    <IconButton
                                        aria-label="edit"
                                        color="primary"
                                        onClick={handleEditToggle}
                                    >
                                        <FiEdit2 />
                                    </IconButton>
                                ))}
                            {!isNewRole && (
                                <IconButton
                                    aria-label="delete"
                                    color="secondary"
                                    onClick={handleDelete}
                                >
                                    <FiTrash2 />
                                </IconButton>
                            )}
                        </Box>
                    </Stack>

                    {!isNewRole && (
                        <ListView
                            viewTitle={`Usuarios`}
                            columns={userColumns}
                            data={users}
                            loading={loadingUsers}
                        />
                    )}
                </>
            )}
        </Window>
    );
};

export default RoleDetail;
